import {AgentContextType} from "../react.intent";
import React, {useMemo} from "react";
import {useUserData} from "@me8eon/react_authentication";
import {checkAllowedItemForUserByRole} from "../utils/checkAllowedItemForUserByRole";

const AgentContext = React.createContext<AgentContextType<any> | undefined>(undefined);

export const AgentContextProvider = (props: { children: React.ReactNode, intent: AgentContextType<any> }) => {
    const {currentRole} = useUserData();

    const filteredIntent = useMemo(() => {
        if (!props.intent) return undefined;
        const filteredAgents: Record<string, any> = {}
        for (const [agentName, agent] of Object.entries(props.intent.cards.cards)) {
            if (checkAllowedItemForUserByRole(currentRole, agent)) {
                filteredAgents[agentName] = agent;
            }
        }

        return {
            ...props.intent,
            cards: {
                ...props.intent.cards,
                cards: filteredAgents
            }
        };
    }, [currentRole, props.intent]);


    return <AgentContext.Provider value={filteredIntent}>
        {props.children}
    </AgentContext.Provider>
}

export const useAgentContext = () => {
    const context = React.useContext(AgentContext);
    if (context === undefined) {
        throw new Error("useAgentContext must be used within an AgentContextProvider");
    }
    return context;
}